import React from 'react';

function Error() {
	return <div>Error! Page not found</div>;
}

export default Error;
